<template>
    <div id="contendor-principal-salidasDelDia">
        <div id="contenedor-encabezados-salidasDelDia" class="text-left">
            <h1>Salidas del día</h1>
        </div>
        <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
            <div class="flex-grow-1 pl-3"><h4>Búsqueda de cédulas para salida</h4></div>
        </div>
        <div id="contendor-salidasDelDia" class="area container-fluid">
            <!-- <h4>Ingrese la información requerida para filtrar las salidas</h4> -->
            <div id="misSalidas" class="form-inline justify-content-end">
                <h6 @click="evtVerSalidas" class="mr-3"><i class="fas fa-archive"></i>&nbsp;Mis Salidas</h6>
            </div>
            <!-- <div class="d-flex justify-content-end">
                <button type="button" @click="evtVerSalidas" class="btn btn-primary mr-2"><i class="fas fa-archive"></i>&nbsp;&nbsp;Mis Salidas</button>
            </div> -->
            <div class="row">
                <div id="filtros-envideCedulas" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-4">
                    <FiltrosDeBusqueda class=""
                        :posicionHorizontal="true"
                        :conSwitchHabilitacion="true"
                        :catalogos="filtrosDeBusqueda" 
                        :ejecutaLaFuncion="evtObtenerCedulasParaSalida" 
                        :filtrosEstablecidos="filtrosEstablecidos"
                        :tituloDeBusqueda="'Paso 1: Busque las cédulas.'"
                        v-on:cambioTipoDeCedula="evtCambioTipoCedula"
                        v-on:cambioTipoNotificador="evtCambioTipoNotificador"
                        v-on:cambioTipoZona="evtCambioTipoZona"
                        v-on:AccionEnSwitchDeFiltros="evtAccionEnSwitchDeFiltros"
                        :ref="REF_FILTROS_BUSQUEDA"></FiltrosDeBusqueda>
                </div>
                <div id="contenedor-listado-cedulasEncontradas" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-4">
                    <div v-show="!cargandoCedulas" class="mt-4">
                        <div style=" padding: 8px;">
                            <div class="form-inline justify-content-start">
                                <i class="fas fa-clipboard-list mr-sm-2" style="font-size: 25px;"></i>
                                <div class="align-content-center">
                                <h3 style="margin: 0;">Listado de cédulas encontradas</h3>
                                </div>
                            </div>
                        </div>
                        <div :class="[cedulasSalida.some(c => c.enviar) ? '' : ' mb-contenedor-p2']">
                            <div>
                                <div class="form-inline justify-content-end mb-3">
                                    <div id="filtros-input-cedulas-memoria" class="form-inline justify-content-end pr-0">
                                        <h6 for="f-busqueda" class="mr-sm-2">Buscar:</h6>
                                        <input v-model="tablaResultadosBusqueda.filtroBusqueda" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control flex-grow-1"/>
                                    </div>
                                </div>
                                <CTablaGenericaCedulas class="table-responsive"
                                    :idDelInput="ID_TABLA_CEDULAS_ENCONTRADAS"
                                    :encabezadosColumnas="encabezadosColumnas"
                                    :accionesEnTabla="this.TABLA_CEDULAS_SELECCIONADA_ACCIONES"
                                    :listaDeCedulas="tablaResultadosBusqueda.cedulasConFiltros"
                                    v-on:elementosSeleccionados="evtObtenerCedulasSeleccionadas"
                                    :conResponsive="true"
                                    v-on:accionFuncionDetalles="evtDetallesDeCedula"
                                    :ref="tablaResultadosBusqueda.REF_T_CEDULAS"></CTablaGenericaCedulas>
                            </div>
                        </div>
                    </div>
                    <div v-show="cargandoCedulas" class="contenedor-cargando" style="height: 300px ;">
                        <div class="text-center">
                            <i class="fas fa-spinner fa-spin fa-5x"></i>
                            <h4 class="mt-4">Cargando Cedulas</h4>
                        </div>
                    </div>
                    <div v-if="cedulasSalida.some(c => c.enviar) && !cargandoCedulas" id="contenedor-campos-informativos-salidas">
                        <h6>[#Cédulas seleccionadas para salida: {{obtenerNumeroDeCedulasParaSalida + ']'}}</h6>
                        <button @click="evtGuardarSalidaModal" type="button" class="btn btn-primary justify-content-end"><i class="fas fa-running"></i>&nbsp;&nbsp;Registrar Salidas</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL CON FECHA DE SALIDA -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formulario-fecha-salida">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Formulario registro de cedulas en salida</h5>
                        <button id="btn-cerrar-formulario-fecha-salida" @click="formularioGuardarSalida.mostrarError = false" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div id="contenedor-error-formulario" v-if="formularioGuardarSalida.mostrarError">
                            <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en formulario</h6>
                            <span style="text-align: justify; display:block;">{{ formularioGuardarSalida.mensajeError }}</span>
                        </div>
                        <div class="" style="padding: 1em 1em 1em 1em">
                            <h5>Selecciona la fecha de la salida</h5>
                            <!-- <hr/> -->
                            <div class="form-inline" style="padding: 2em 0 0 0">
                                <h6 for="fecha-salida-gr" class="mr-2">Fecha de salida</h6>
                                <input id="fecha-salida-gr" type="date" v-model="fechaRegistroDeSalida" class="form-control mr-3" />
                                <button type="button" @click="evtGuardarSalida" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                            </div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL PARA VISUALIZAR OBSERVACIONES DE ABOGADOS -->
        <div class="modal align-middle visor-documento" tabindex="-1" data-backdrop="static" data-keyboard="false" id="descripcion-cedula-VSDDN">
          <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title"><i class="fas fa-info-circle"></i>&nbsp;Observaciones de abogado</h5>
                      <button id="'btn-cerrar-descripcion-cedula-VSDDN" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                  </div>
                  <div class="modal-body">
                      <div class="p-2">
                        <div class="form-group info" id="ObservacionesAbogado_div">
                            <h6>Observaciones para cédula [ Folio: #{{ folioCedulaSeleccionada }} ]</h6>
                            <!-- <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/> -->
                            <div v-if="observacionesDeAbogado.length < 1" class="contenedor-observaciones" style="margin: 2em 0 0 0">
                                <h6 class="text-center">Sin observaciones</h6>
                            </div>
                            <div id="contenedor-observacion">
                                <div v-for="(observacion,index) in observacionesDeAbogado" class="form-group" :key="index">
                                    <div class="form-inline">
                                        <h6>[{{obtenerNombreCompleto(observacion)}}]</h6>
                                        <button :id="observacion.ObservacionAbogadoId" type="button" @click="evtEliminarObservacionAbogado($event)" class="ml-2 btn-sm btn-primary"><i :id="observacion.ObservacionAbogadoId" class="fas fa-trash-alt"></i></button>
                                    </div>
                                    <textarea disabled v-model="observacion.Observaciones" type="text" rows="3" class="form-control mt-2"/>
                                </div>
                            </div>
                        </div>
                      </div>
                  </div>  
              </div>
          </div>
      </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import router from '@/router/index'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
    components: {
        FiltrosDeBusqueda: sistemas.SINOJ.FiltrosDeBusqueda,
        CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas
    },
    data() {
        return {
            ID_TABLA_CEDULAS_ENCONTRADAS: 'tablaCedulasSalidasDelDia',
            REF_FILTROS_BUSQUEDA: 'REFCVSDD',
             filtrosDeBusqueda: [
                { catalogoId: 'filtroNumeroFolio', idDelInput: 'FNumFolioVSDD' },
                { catalogoId: enumeraciones.sinoj.catalogos.Notificadores, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Notificador_SalidasDelDia' },
                { catalogoId: enumeraciones.sinoj.catalogos.Zonas, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Zonas_SalidasDelDia' },
                { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_SalidasDelDia' },
                { catalogoId: enumeraciones.catalogos.FechaDeInicio },
                { catalogoId: enumeraciones.catalogos.FechaFinal },
                { catalogoId: enumeraciones.sinoj.catalogos.TiposDeCedula, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoCedula_SalidasDelDia' },
            ],
            filtrosEstablecidos: {},
            encabezadosColumnas: ['Folio','Consecutivo','Urgente','Domicilio','Persona a notificar','Tipo de cédula','#Salidas', '#Constituciones',''],
            TABLA_CEDULAS_SELECCIONADA_ACCIONES: {motrarAcciones: true,check: true, eliminar: false, detalles: true},
            listaDeCedulas: [],
            fechaDeBusqueda: moment().format('YYYY-MM-DD'),
            mostrarCedulasEncontradas: false,
            cedulasParaSalidaBD: [],
            cedulasParaSalida: [],
            cedulasSalida: [],
            mesajeSinCedulas: 'No se ha realizado ninguna búsqueda, en el paso 1 presione el botón de Buscar.',
            cargandoCedulas: false,
            numeroCedulasParaSalida: 0,
            tipoZonaId: -1,
            tipoNotificadorId: -1,
            tipoDeCedulaId: -1,
            numeroDeDocumento: null,
            cambiarFiltros: false,
            FILTROS_CARGADOS_PREVIAMENTE: null,
            fechaInicial: null,
            fechaFinal: null,
            objCancelarFiltros: null,
            observacionesDeAbogado: [],
            folioCedulaSeleccionada: null,
            filtrosDeBusquedaSecciones: {
                expediente: true,
                cedula: true,
                fechas: true
            },
            salida: {
                cedulas: []
            },
            tablaResultadosBusqueda: {
                filtroBusqueda: null,
                cedulasConFiltros: [],
                REF_T_CEDULAS: 'RefTablaCedulasVSDD'
            },
            FILTROS_CARGADOS: null,
            filtrosVistaHija: null,
            fechaRegistroDeSalida: moment().format('YYYY-MM-DD'),
            formularioGuardarSalida: {
                mensajeError: null,
                mostrarError: false
            },
            usuarioEsDeJuzgadoMixto: false,
            cargoAreaDeUsuario: false
        }
    },
    methods: {
        filtrarCedulasTabla: function(e) {
            // filtra por columnas y nivel de prioridad
            this.tablaResultadosBusqueda.cedulasConFiltros = this.cedulasParaSalida
            .filter(c => {
                return Object.values(c).some(valorColumna => this.predicateFiltradoPorSimilitud(valorColumna, this.tablaResultadosBusqueda.filtroBusqueda));
            })
            this.obtenerPersistenciaDeSeleccion();
        },
        obtenerPersistenciaDeSeleccion: function() {
            if(this.tablaResultadosBusqueda.cedulasConFiltros.length > 0) {
                let cedulasSeleccionadasConFiltros = [];
                //console.log('cedulasSalida::',this.cedulasSalida);
                this.tablaResultadosBusqueda.cedulasConFiltros
                .forEach(cf => {
                    const CEDULA_SELECCIONADA = this.cedulasSalida.find(cs => cs.folio == cf.Folio);
                    //console.log('CEDULA_SELECCIONADA::',CEDULA_SELECCIONADA);
                    if(this.campoRequeridoEsValido(CEDULA_SELECCIONADA))
                       cedulasSeleccionadasConFiltros.push(CEDULA_SELECCIONADA); 
                });
                //console.log('cedulasSeleccionadasConFiltros::',cedulasSeleccionadasConFiltros);
                this.cedulasSalida = cedulasSeleccionadasConFiltros;
                this.numeroCedulasParaSalida = this.cedulasSalida.length;
            }

            // limpia los check seleccionados previamente
            if(this.tablaResultadosBusqueda.cedulasConFiltros.length == 0) {
                this.cedulasSalida = [];
                this.numeroCedulasParaSalida = this.cedulasSalida.length;
            }
            
            this.$nextTick(() => {
                this.cedulasSalida.filter(c => c.enviar).forEach(cedulaSeleccionada => {
                    this.$refs[this.tablaResultadosBusqueda.REF_T_CEDULAS].seleccionDeCedulaComponentePadre(cedulaSeleccionada.idCheck);
                });
            });
        },
        predicateFiltradoPorSimilitud: function(elementoAEvaluar,compararCon) { 
            if(this.campoRequeridoEsValido(compararCon)) {
            if(elementoAEvaluar.toString().toUpperCase().startsWith(compararCon.toString().toUpperCase()))
                return true;
            else
                return false;
            }
            else
                return true;
        },
        evtAccionEnSwitchDeFiltros: function(accionRealizada) {
            switch(accionRealizada.tipoDeFiltro) {
                case 'Expediente':
                    this.filtrosDeBusquedaSecciones.expediente = accionRealizada.habilitar;
                    break;
                case 'Cedula':
                    this.filtrosDeBusquedaSecciones.cedula = accionRealizada.habilitar;
                    break;
                case 'Fechas':
                    this.filtrosDeBusquedaSecciones.fechas = accionRealizada.habilitar;
                    break;
                default:
                    break;
            };
        },
        eliminarObservacionBD: function(peticionAPI) {
            const SERVIDOR = api.conexion;
            const METODO_API_ELIMINAR = api.SINOJ.sistema.notificaciones.salidasDelDia.EliminarObservacionesDeAbogado;
            let urlApi = SERVIDOR + METODO_API_ELIMINAR;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else { debugger
                            const CEDULA_ACTUALIZADA = respuesta.data.Cedula;
                            console.log(CEDULA_ACTUALIZADA);
                            if(this.campoRequeridoEsValido(CEDULA_ACTUALIZADA)) {
                                console.log('this.cedulasParaSalidaBD::',this.cedulasParaSalidaBD);
                                this.cedulasParaSalidaBD.filter(c => c.CedulaId == CEDULA_ACTUALIZADA.CedulaId).forEach(ca => {
                                    ca.ObservacionesDeAbogados = CEDULA_ACTUALIZADA.ObservacionesDeAbogados;
                                    this.observacionesDeAbogado = ca.ObservacionesDeAbogados;
                                });
                                /* const INDEX_CEDULA_SIN_ACTUALIZAR = this.cedulasParaSalidaBD.findIndex(c => c.CedulaId == peticionAPI.Cedula.CedulaId);
                                if(this.campoRequeridoEsValido(INDEX_CEDULA_SIN_ACTUALIZAR)) {
                                    this.cedulasParaSalidaBD[INDEX_CEDULA_SIN_ACTUALIZAR].ObservacionesDeAbogados = CEDULA_ACTUALIZADA.ObservacionesDeAbogados;
                                    this.observacionesDeAbogado = this.cedulasParaSalidaBD[INDEX_CEDULA_SIN_ACTUALIZAR].ObservacionesDeAbogados;
                                } */
                            }
                        }
                        $('#descripcion-cedula-VSDDN').modal('show');
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        informarConfirmacionDeEliminarObservacion: function (idObservacion) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `Estas seguro que deseas eliminar la observación<br>¿Desea continuar?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        let peticionEliminarObservacion = {
                            Cedula: {
                                CedulaId: this.folioCedulaSeleccionada,
                                ObservacionesDeAbogados: [
                                    { ObservacionAbogadoId: idObservacion }
                                ]
                            },
                            esPrueba: false
                        }
                        this.eliminarObservacionBD(peticionEliminarObservacion);
                    }
                    else {
                        $('#descripcion-cedula-VSDDN').modal('show');
                    }
                }
            });
        },
        evtEliminarObservacionAbogado: function(evento) {
            $('#descripcion-cedula-VSDDN').modal('hide');
            const OBSERVACION_SELECCIONADA = parseInt(evento.target.getAttribute('id'));
            this.informarConfirmacionDeEliminarObservacion(OBSERVACION_SELECCIONADA);
        },
        obtenerNombreCompleto: function(observacion) {
            const USUARIO_OBSERVACION = observacion.Usuario;
            if(USUARIO_OBSERVACION == null) {
                return 'Sin usuario';
            }
            const DATOS_NOMBRE = [USUARIO_OBSERVACION.Nombre, USUARIO_OBSERVACION.ApellidoPaterno, USUARIO_OBSERVACION.ApellidoMaterno];
            return DATOS_NOMBRE.join(' ');
        },
        evtDetallesDeCedula: function(evento) {
            const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
            const ID_CEDULA = parseInt(this.obtenerCedula(CEDULA_SELECCIONADA));
            this.observacionesDeAbogado = [];
            const DATOS_CEDULA = this.cedulasParaSalidaBD.find(c => c.CedulaId == ID_CEDULA);
            if(this.campoRequeridoEsValido(DATOS_CEDULA)) {
                const { ObservacionesDeAbogados, CedulaId } = DATOS_CEDULA;
                this.folioCedulaSeleccionada = CedulaId;
                if(ObservacionesDeAbogados != null) 
                    this.observacionesDeAbogado = ObservacionesDeAbogados;
            }
            $('#descripcion-cedula-VSDDN').modal('show');
        },
        obtenerCedula: function(cedulaSeleccionada) {
            const CEDULA = cedulaSeleccionada.split('-');
            const POSICION_ID = (CEDULA.length - 1);
            const ID_CEDULA = CEDULA[POSICION_ID];
            return ID_CEDULA;
        },
        evtCanclarFiltros: function() {
            $("#contenedor-listado-cedulasEncontradas").removeClass("desabilitar-contenedor-buscarCedula");
            $("#filtros-envideCedulas").addClass("desabilitar-contenedor-buscarCedula");
            this.cambiarFiltros = true;
            this.objCancelarFiltros = null;
        },
        evtCambiarFiltrosBusqueda: function() {
            $("#filtros-envideCedulas").removeClass("desabilitar-contenedor-buscarCedula");
            $("#contenedor-listado-cedulasEncontradas").addClass("desabilitar-contenedor-buscarCedula");
            this.objCancelarFiltros = { funcion: this.evtCanclarFiltros };
            this.cambiarFiltros = false;
        },
        evtVerSalidas: function() {
            if(this.tipoNotificadorId > 0) {
                 //const FILTROS_CARGADOS_PREVIAMENTE = this.obtenerFiltrosDeBusquedaCargados();
                 router.push({ name: "SalidasDeNotificador", params: { idNotificador: this.tipoNotificadorId, filtrosPrevios: this.FILTROS_CARGADOS, filtrosPreviosVistaHija: this.filtrosVistaHija } });
            }
            else {
                comun.mensajeDeAlerta('No hay notificador seleccionado');
            }
        },
        evtObtenerCedulasSeleccionadas: function(evento) { 
            this.cedulasSalida = evento.filter(c => c.enviar);
            this.numeroCedulasParaSalida = this.cedulasSalida.length;
        },
        evtObtenerCedulasParaSalida: function() {
           /* let hayCedulasSeleccionadas = this.cedulasSalida.some(c => c.enviar);
           this.mesajeSinCedulas = (this.mesajeSinCedulas != 'No se encontraron cedulas') ? 'No se encontraron cedulas' : this.mesajeSinCedulas;
           this.objCancelarFiltros = null;
           if(hayCedulasSeleccionadas)
              this.confirmacionPerdidaCedulasSeleccionadas();
           else
              this.obtenerCedulasParaSalidasBD(); */
            this.mesajeSinCedulas = (this.mesajeSinCedulas != 'No se encontraron cédulas') ? 'No se encontraron cédulas' : this.mesajeSinCedulas;
            this.tablaResultadosBusqueda.filtroBusqueda = null;
            this.obtenerCedulasParaSalidasBD();
        },
        evtCambioTipoCedula: function(evento) {
            const TIPO_CEDULA_ID = parseInt(evento.target.value);
            this.tipoDeCedulaId = (TIPO_CEDULA_ID > 0) ? TIPO_CEDULA_ID : -1;
        },
        evtCambioTipoNotificador: function(evento) {
            const TIPO_NOTIFICADOR_ID = parseInt(evento.target.value);
            this.tipoNotificadorId = (TIPO_NOTIFICADOR_ID > 0) ? TIPO_NOTIFICADOR_ID : -1;
        },
        evtCambioTipoZona: function(evento) {
            const TIPO_ZONA_ID = parseInt(evento.target.value);
            this.tipoZonaId = (TIPO_ZONA_ID > 0) ? TIPO_ZONA_ID : -1;
            this.tipoNotificadorId = -1;
        },
        buscarCedulas: function() {
            /* this.mostrarCedulasEncontradas = true;
             $("#filtros-envideCedulas").addClass("desabilitar-contenedor-buscarCedula");
             $("#btn-cambiarFiltros-salidas").prop('disabled', false); */
        },
        /* cambiarFiltros: function() {
            $("#filtros-envideCedulas").removeClass("desabilitar-contenedor-buscarCedula");
            $("#btn-cambiarFiltros-salidas").removeClass("visited");
            $("#btn-cambiarFiltros-salidas").removeClass("active");
            $("#btn-cambiarFiltros-salidas").prop('disabled', true);
        }, */
        evtGuardarSalida: function() {
            const DIA_ACTUAL = moment().format('YYYY-MM-DD');
            if(this.fechaRegistroDeSalida != null && this.fechaRegistroDeSalida >= DIA_ACTUAL) {
                this.formularioGuardarSalida.mensajeError = null;
                this.formularioGuardarSalida.mostrarError = false;
                if(this.tipoNotificadorId > 0) {
                    let peticionAPI = this.crearPeticionNuevaSalida();
                    console.log('peticionAPI::salidas::',peticionAPI);
                    this.guardarSalidaBD(peticionAPI);
                }
                else {
                    comun.mensajeDeAlerta('No hay notificador seleccionado.');
                }
            }
            else {
                this.formularioGuardarSalida.mensajeError = "No se puede guardar registros de cédulas en una salida con fecha anterior al dia de hoy"
                this.formularioGuardarSalida.mostrarError = true; 
            }
        },
        evtGuardarSalidaModal: function() {
            $('#formulario-fecha-salida').modal('show');
        },
        crearPeticionNuevaSalida: function() {
            let peticion = {};
            peticion.Salida = this.cedulasSalida.filter(ce => ce.enviar).map(c => {
                let salida = {};
                salida.SalidaId = -1;
                salida.FechaSalida = this.fechaRegistroDeSalida;
                salida.Notificador = {
                    NotificadorId: this.tipoNotificadorId
                },
                salida.Cedula = {
                    CedulaId: c.folio
                }
                return salida;
            });
            peticion.esPrueba = false;
            return peticion;
        },
        guardarSalidaBD: function(peticionAPI) {
            const SERVIDOR = api.conexion;
            const METODO_API_AGREGAR = api.SINOJ.sistema.notificaciones.salidasDelDia.GuardarNuevaSalida;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            $('#formulario-fecha-salida').modal('hide');
            comun.SeEstaCargandoInformacion(true);
            this.cargandoCedulas = true;
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("obtenerCedulasParaSalidaBD::ejecuto bien:: ",respuesta.data);
                            // Elimina las cedulas que se enviaron de las cedula cargadas previamente en memoria
                            /* this.cedulasParaSalidaBD = this.cedulasParaSalidaBD.filter(cbd => {
                                return !peticionAPI.Salida.some(s => s.Cedula.CedulaId == cbd.CedulaId);
                            });
                            this.cedulasParaSalida = this.darFormatoCedulasTabla(this.cedulasParaSalidaBD);
                            this.tablaResultadosBusqueda.cedulasConFiltros = this.cedulasParaSalida; */
                            // se limpia la lista de cedulasAEnviar
                            this.cedulasSalida = [];
                            this.obtenerCedulasParaSalidasBD();
                            /* this.$nextTick(() => {
                                $("#filtros-input-cedulas-memoria input").on("change paste keyup", (e) => {
                                    if(this.cedulasParaSalida.length > 0 && !this.cargandoCedulas) {
                                        this.filtrarCedulasTabla(e);
                                    }
                                });
                            });
                            this.obtenerFiltrosDeBusquedaCargados();
                            this.obtenerPersistenciaDeSeleccion(); */
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio);
                        }
                        this.cargandoCedulas = false;
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        this.cargandoCedulas = false;
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        obtenerCedulasParaSalidasBD: function() {
           const SERVIDOR = api.conexion;
           const METODO_API_OBTENER = api.SINOJ.sistema.notificaciones.salidasDelDia.ObtenerCedulasParaSalidas;
           let urlApi = SERVIDOR + METODO_API_OBTENER;
           let peticionAPI = {
                Folio: (this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].numeroDeFolio) && this.filtrosDeBusquedaSecciones.cedula) ? this.$refs[this.REF_FILTROS_BUSQUEDA].numeroDeFolio : null,
                NumeroDeDocumento:this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo : null,
                TipoCedulaId: (this.tipoDeCedulaId < 0) || !this.filtrosDeBusquedaSecciones.cedula ? null : this.tipoDeCedulaId,
                ZonaId: (this.tipoZonaId < 0) ? null : this.tipoZonaId,
                NotificadorId: (this.tipoNotificadorId < 0) ? null : this.tipoNotificadorId,
                FechaInicial: this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].fechaInicial) && this.filtrosDeBusquedaSecciones.fechas ? this.$refs[this.REF_FILTROS_BUSQUEDA].fechaInicial : null,
                FechaFinal: this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].fechaFinal) && this.filtrosDeBusquedaSecciones.fechas ? this.$refs[this.REF_FILTROS_BUSQUEDA].fechaFinal : null
            };
            peticionAPI.esPrueba = false;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            this.cargandoCedulas = true;
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("obtenerCedulasParaEnvioBD::ejecuto bien:: ",respuesta.data);
                            this.cedulasParaSalidaBD = (respuesta.data.Cedulas != null) ? respuesta.data.Cedulas : [];
                            this.cedulasParaSalida = this.darFormatoCedulasTabla(this.cedulasParaSalidaBD);
                            this.tablaResultadosBusqueda.cedulasConFiltros = this.cedulasParaSalida;
                            // deshabilitacion de filtros
                            /* $("#filtros-envideCedulas").addClass("desabilitar-contenedor-buscarCedula");
                            $("#contenedor-listado-cedulasEncontradas").removeClass("desabilitar-contenedor-buscarCedula");
                            this.cambiarFiltros = true; */
                            this.cargandoCedulas = false;
                            this.$nextTick(() => {
                                $("#filtros-input-cedulas-memoria input").on("change paste keyup", (e) => {
                                    if(this.cedulasParaSalida.length > 0 && !this.cargandoCedulas) {
                                        this.filtrarCedulasTabla(e);
                                    }
                                });
                            });
                            this.obtenerFiltrosDeBusquedaCargados();
                            this.obtenerPersistenciaDeSeleccion();
                        }
                        this.cargandoCedulas = false;
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        this.cargandoCedulas = false;
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
         /**
         * funcion encargado de dar formato a objetos de cedula al formato
         * [Folio,Urgente,Tipo de cedula,Fecha de asignación] que ocupa la
         * tabla de la vista. 
         * @param {object} cedulas [fuente de datos de cedulas]
         * @see {@link cedulaAObjetoTabla}
         */
        darFormatoCedulasTabla: function(cedulas) {
            let cedulasConFormato = [];
            cedulasConFormato = cedulas.map(c => {
                let cedula = this.cedulaAObjetoTabla(c);
                return cedula;
            });
            return cedulasConFormato;
        },
        cedulaAObjetoTabla: function(cedula) {
            let cedulaObjTabla = {};
            cedulaObjTabla.Folio = cedula.CedulaId;
            cedulaObjTabla.Consecutivo = 'Sin consecutivo'; 
            if(this.campoRequeridoEsValido(cedula.Expediente)) { 
                cedulaObjTabla.Consecutivo = cedula.Expediente.NumeroDeDocumento; 
            }
            cedulaObjTabla.urgente = (cedula.Urgente) ? 'SI' : 'NO';
            cedulaObjTabla.Domicilio = 'Sin Domicilio';
            cedulaObjTabla.PersonaANotificar = 'Sin Persona a Notificar';
            if(this.campoRequeridoEsValido(cedula.PersonasANotificar)) {
                if(cedula.PersonasANotificar[0].Domicilios != null && cedula.PersonasANotificar[0].Domicilios.length > 0) {
                    const DOMICILIO_OBJ = cedula.PersonasANotificar[0].Domicilios[0];
                    let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                    let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
                    if(this.campoRequeridoEsValido(DOMICILIO_OBJ.Fraccionamiento)) {
                        cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`;
                    }
                    else {
                        /* 
                            para los casos de domicilios con fraccionamiento que no pertenece al catalogo de fraccionamientos, se guarda la informacion el un solo campo (008FraccionamientoFueraDeCatalogo => FraccionamientoFueraDeCatalogo)
                            con el siguiente formato NOMBRE_FRACCIONAMIENTO, NOMBRE_MUNICIPIO, si se modifica posteriormenete este formato se tendra que reemplazar esta 
                            logica.
                            */
                        let fraccionamientoCompuesto = DOMICILIO_OBJ.FraccionamientoFueraDeCatalogo.split(',');
                        let nombreFraccionamiento = fraccionamientoCompuesto[0];
                        let nombreMunicipio = fraccionamientoCompuesto[1];
                        cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
                    }

                    /* const DOMICILIO_OBJ = cedula.PersonaANotificar.Domicilios[0];
                    let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                    let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior }` : '';
                    cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`; */
                }
                
                if(this.campoRequeridoEsValido(cedula.PersonasANotificar[0].DatosGenerales)) {
                    const { Fisica, Moral } = cedula.PersonasANotificar[0].DatosGenerales;
                    if(this.campoRequeridoEsValido(Fisica))
                        cedulaObjTabla.PersonaANotificar = `${ Fisica.Nombre.toUpperCase().trim() } ${ Fisica.ApellidoPaterno.toUpperCase().trim() }${ (this.campoRequeridoEsValido(Fisica.ApellidoMaterno)) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
                    else if(this.campoRequeridoEsValido(Moral))
                        cedulaObjTabla.PersonaANotificar = `${ Moral.Nombre.trim() }`; 
                }
            }
            
            cedulaObjTabla.TipoCedula = (this.campoRequeridoEsValido(cedula.TipoCedula.Nombre)) ? cedula.TipoCedula.Nombre.trim() : 'Sin tipo de cdula';
            // la cedula tiene una lista de asignaciones (activas, inactivas) pero activa siempre sera una, index = [0]
            // cedulaObjTabla.fechaAsignacion = cedula.AsignacionesDeNotificador[0].FechaDeAsignacion;
            cedulaObjTabla.numeroSalidas = 0;
            cedulaObjTabla.numeroConstituciones = 0;
            if(cedula.Salidas != null && cedula.Salidas.length > 0) {
                cedulaObjTabla.numeroSalidas = cedula.Salidas.length;
                let numeroDeContituciones = cedula.Salidas.filter(s => s.Constituciones != null).length;
                cedulaObjTabla.numeroConstituciones = numeroDeContituciones;
            }
            return cedulaObjTabla;
        },
        /**
         * Metodo encargado de mostrar alerta bootbox para confirmacion. 
         * @param {object} notificador [asignacion que que se removera]
         * @see {@link eliminarNoticadorBD}
         */
        confirmacionPerdidaCedulasSeleccionadas: function () {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `Se encuentran cédulas seleccionas para salida,<br> si deseas continuar se perdera la informacion.`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.cedulasSalida = [];
                        this.obtenerCedulasParaSalidasBD();
                    }
                }
            });
        },
        obtenerFiltrosDeBusquedaCargados: function() {
            this.FILTROS_CARGADOS = {
                NumeroDeDocumento: this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo,
                TipoCedulaId: this.tipoDeCedulaId,
                TipoZonaId: this.tipoZonaId,
                NotificadorId: this.tipoNotificadorId,
                FechaInicial: this.$refs[this.REF_FILTROS_BUSQUEDA].fechaInicial,
                FechaFinal: this.$refs[this.REF_FILTROS_BUSQUEDA].fechaFinal,
                FiltrosHabilitados: this.filtrosDeBusquedaSecciones
            }
        },
        campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'array' || campo instanceof Array) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo.length > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      asignarValoresUsuarioNotificador: async function() { debugger
          try {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.notificaciones.salidasDelDia.ObtenerDatosDeNotificador;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionAPI = { esPrueba: false };
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            this.cargandoCedulas = true;
            const PETICION_NOTIFICADOR = await axios.post(urlApi, peticionAPI, headerPeticion);
            const DATOS_PETICION = await PETICION_NOTIFICADOR.data;
            let { SiHayError, Error, Notificador } = DATOS_PETICION;
            if (SiHayError) {
                let mensajeError = Error.Mensaje;
                comun.SeEstaCargandoInformacion(true);
                console.log(mensajeError);
                router.push({ name: "SINOJ"});
                comun.mensajeDeAlerta(mensajeError, null, null);
            } 
            else {
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Zonas.esInformativo = true;
                if(Notificador.Zona != null) {
                    this.tipoZonaId = Notificador.Zona.ZonaId;
                    this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Zonas.valorDefinido = this.tipoZonaId;
                    this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Zonas.key = 'CFTZ' + this.contadorRenderFiltros;
                }
                this.tipoNotificadorId = Notificador.NotificadorId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Notificadores.esInformativo = this.campoRequeridoEsValido(Notificador.NotificadorId) ? true : false;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Notificadores.valorDefinido = Notificador.NotificadorId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Notificadores.key = 'CFTN' + this.contadorRenderFiltros;
            }
          }
          catch(excepcion) {
              comun.SeEstaCargandoInformacion(false);
              console.log(excepcion);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
      },
       esJuzgadoMixto: function(area) { 
          const { AreaId } = area;
          const JUZGADOS_MIXTOS = Object.values(enumeraciones.sinoj.juzgadosMixtos);
          if(this.campoRequeridoEsValido(JUZGADOS_MIXTOS)) {
            this.usuarioEsDeJuzgadoMixto = JUZGADOS_MIXTOS.some(jz => jz == AreaId);
          }
      },
      ...mapActions([
        'A_SINOJ_establecerCedulasSeleccionadas_SalidasDelDia',
        'A_SINOJ_establecerCedulasSeleccionadas_SalidasDeNotificador'
      ])  
    },
    async mounted() {
        if(this.FILTROS_CARGADOS_PREVIAMENTE != null && this.FILTROS_CARGADOS_PREVIAMENTE != undefined) {
            // renderizar catalogos de componente hijo filtrosDeBusqueda con valor elegido previamente
            if(this.FILTROS_CARGADOS_PREVIAMENTE.cargarConFiltros) {
                this.contadorRenderFiltros += 1;
                this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo = this.numeroDeDocumento;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TiposCedula.valorDefinido = this.tipoDeCedulaId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TiposCedula.key = 'CFTC' + this.contadorRenderFiltros;
               /* this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Zonas.valorDefinido = this.tipoZonaId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Zonas.key = 'CFTZ' + this.contadorRenderFiltros;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Notificadores.valorDefinido = this.tipoNotificadorId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Notificadores.key = 'CFTN' + this.contadorRenderFiltros; */
                this.$refs[this.REF_FILTROS_BUSQUEDA].fechaInicial = this.fechaInicial;
                this.$refs[this.REF_FILTROS_BUSQUEDA].fechaFinal = this.fechaFinal;
            }
            //carga los valores de los switch para la deshabilitacion de filtros
            if(this.FILTROS_CARGADOS_PREVIAMENTE.FiltrosHabilitados != null) {
                const { expediente, cedula, fechas } = this.FILTROS_CARGADOS_PREVIAMENTE.FiltrosHabilitados;
                // switch filtros expediente
                if(expediente)
                    this.$refs[this.REF_FILTROS_BUSQUEDA].evtHabilitarFiltros('Expediente');
                else
                    this.$refs[this.REF_FILTROS_BUSQUEDA].evtDeshabilitarFiltros('Expediente');
                // switch filtros cedula
                if(cedula)
                    this.$refs[this.REF_FILTROS_BUSQUEDA].evtHabilitarFiltros('Cedula');
                else
                    this.$refs[this.REF_FILTROS_BUSQUEDA].evtDeshabilitarFiltros('Cedula');
                // switch filtros fechas
                if(fechas)
                    this.$refs[this.REF_FILTROS_BUSQUEDA].evtHabilitarFiltros('Fechas');
                else
                    this.$refs[this.REF_FILTROS_BUSQUEDA].evtDeshabilitarFiltros('Fechas');
            }
        }
        
        if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area)) {
            this.cargoAreaDeUsuario = true;
            this.esJuzgadoMixto(this.$store.state.Login_Usuario.Area);

            if(!this.usuarioEsDeJuzgadoMixto)
                await Promise.resolve(this.asignarValoresUsuarioNotificador());
            this.obtenerCedulasParaSalidasBD();
        }
    },
    created() {
        this.mesajeSinCedulas = 'No se ha realizado ninguna búsqueda, en el paso 1 presione el botón de Buscar.';
        //console.log('props::',router.history.current.params);
        this.FILTROS_CARGADOS_PREVIAMENTE = router.history.current.params.filtrosParaCargar;
        if(this.FILTROS_CARGADOS_PREVIAMENTE != null && this.FILTROS_CARGADOS_PREVIAMENTE != undefined) {
            if(this.FILTROS_CARGADOS_PREVIAMENTE.cargarConFiltros) {
                this.numeroDeDocumento = this.FILTROS_CARGADOS_PREVIAMENTE.NumeroDeDocumento;
                this.tipoDeCedulaId = this.FILTROS_CARGADOS_PREVIAMENTE.TipoCedulaId;
                this.tipoZonaId = this.FILTROS_CARGADOS_PREVIAMENTE.TipoZonaId;
                this.tipoNotificadorId = this.FILTROS_CARGADOS_PREVIAMENTE.NotificadorId;
                this.fechaInicial = this.FILTROS_CARGADOS_PREVIAMENTE.FechaInicial;
                this.fechaFinal = this.FILTROS_CARGADOS_PREVIAMENTE.FechaFinal;
            }
        }

        const FECHA_BUSQUEDA_VISTA_HIJA = router.history.current.params.filtrosPreviosVistaHija;
        if(FECHA_BUSQUEDA_VISTA_HIJA != null && FECHA_BUSQUEDA_VISTA_HIJA != undefined) {
            this.filtrosVistaHija = FECHA_BUSQUEDA_VISTA_HIJA;
        }

        if(this.obtenerCedulasSeleccionadasPrevias != null && this.obtenerCedulasSeleccionadasPrevias.length > 0) {
            this.cedulasSalida = this.obtenerCedulasSeleccionadasPrevias;
        }
    },
    watch: {
        'cedulasSalida': function() {
            this.A_SINOJ_establecerCedulasSeleccionadas_SalidasDelDia(this.cedulasSalida.filter(c => c.enviar));
            let todosLosElementosSeleccionados = (this.cedulasSalida.filter(c => c.enviar).length == this.tablaResultadosBusqueda.cedulasConFiltros.length);
            this.$refs[this.tablaResultadosBusqueda.REF_T_CEDULAS].mostrarSeleccionTodoComponentePadre(todosLosElementosSeleccionados);
        },
        '$store.state.Login_Usuario.Area': async function() {
            if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area) && !this.cargoAreaDeUsuario) {
                this.cargoAreaDeUsuario = true;
                this.esJuzgadoMixto(this.$store.state.Login_Usuario.Area);
                
                if(!this.usuarioEsDeJuzgadoMixto)
                    await Promise.resolve(this.asignarValoresUsuarioNotificador());
                this.obtenerCedulasParaSalidasBD();
            }
        }
    },
    computed: {
        obtenerNumeroDeCedulasParaSalida() {
            return this.numeroCedulasParaSalida;
        },
        obtenerCedulasSeleccionadasPrevias() {
            return this.$store.getters.Get_SINOJ_CedulasSeleccionadas_SalidasDelDia;
        },
    },
    beforeRouteLeave (to, from, next) {
        const VISTA_HIJA = 'SalidasDeNotificador';
        if(to.name != VISTA_HIJA) {
          this.A_SINOJ_establecerCedulasSeleccionadas_SalidasDelDia([]);
          this.A_SINOJ_establecerCedulasSeleccionadas_SalidasDeNotificador([]);
        }
        next();
    }
}
</script>
<style scoped>
    #filtros-input-cedulas-memoria {
        width: 50vmin;
    }

    #contenedor-campos-informativos-salidas {
        align-items: center;
        justify-content: center;
        margin-top: 2em; 
        display:flex; 
        justify-content: space-between;
        margin-top: 2em;
    }

    .contenedor-color-negro {
        padding: 1.5em;
        background-color: #2c2d31;
        box-shadow: 0px 6px 20px 8px #161616;
    }

    #fecha-busqueda-informacion {
        background-color: #1e2020;
        height: 4em;
    }

     #titulo-tabla {
        background-color: #1b1919;
        margin-top:2em;
        padding: 10px;
        margin-bottom: 0px;
        display: flex;
        justify-content: center;
    }

    .desabilitar-contenedor-buscarCedula {
        pointer-events: none;
        opacity: 0.6;
    }

    .btn-primary:hover {
        color: white;
        background-color: black;
        border-color: white;
    }

    .btn-primary:focus {
        color: white;
        background-color: black;
        border-color: white;
        box-shadow: none;
    }

   .btn-primary:active, .btn-primary:visited {
        background-color: black !important;
        box-shadow: none !important;
    }

    .btn.btn-primary:disabled{
        background-color: black;
    }

    .contenedor-color-negro {
        padding: 1.5em;
        background-color: #2c2d31;
        box-shadow: 0px 6px 20px 8px #161616;
    }

    .contenedor-sin-cedula {
        background-color: rgb(36, 34, 34);
        height: 40px;
        height: 21rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .contenedor-cargando {
        background-color: rgb(36, 34, 34);
        height: 40px;
        height: 21rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .mb-contenedor-p2 {
        margin-bottom: 30px;
    }

    .btn-sm {
        cursor: pointer;
    }

    #encabezado-contenedor-contenido {
        background-color: rgb(44, 43, 43);
        padding: 10px;
    }

    #misSalidas h6:hover, #misSalidas h6:focus {
        text-decoration-line: underline;
        font-weight: bold;
        cursor: pointer;
    }

    .visor-documento .modal-lg {
        max-width: 50% !important;
    }

    .visor-documento .modal-header {
        background-color: rgb(36, 34, 34);;
        border: none;
    }

    .contenedor-observaciones {
        background-color: #242425;
        max-height: 16em;
        overflow-y: auto;
        padding: 8px;
        border-radius: 4px;
    }

    #contenedor-observacion {
        margin-top: 1em;
        padding-right: 10px;
        max-height: 16em;
        overflow-y: auto;
    }

    #contenedor-observacion .btn-sm {
        width: 25px;
        height: 25px;
        padding: 0;
        cursor: pointer;
    }

    #contenedor-observacion .btn-primary:active:hover,
    #contenedor-observacion .btn-primary:hover,
    #contenedor-observacion .btn-primary:focus {
        border-color: black;
        background-color: black;
    }

    #contenedor-error-formulario {
        padding: 1em;
        background-color: #26272b;
        border: 1px solid #5c5959;
        border-radius: 8px;
        margin-bottom: 1em;
    }

    #formulario-fecha-salida .modal-lg {
        max-width: 40% !important;
    }

    #formulario-fecha-salida .modal-header {
        background-color: rgb(36, 34, 34);;
        border: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Notificaciones/CedulasParaSalida/CSalidasDelDia.vue